const INTX_ACTIVE_CLASS = 'is-active';

const PrepareInteractiveText = () => {
    const desktopITTab = document.querySelectorAll('.intb-desktop-tab');

    desktopITTab.forEach(ItTab => {
        const desktopITContainer = ItTab.querySelectorAll('.intb-desktop-tab-item-container');

        desktopITContainer.forEach(interactiveTextContainer => {
            const buttonContainer = document.createElement('div');
            buttonContainer.classList.add([
                'intb-desktop-button-container'
            ]);

            const removeItemsActiveClass = () => {
                const activeItem = interactiveTextContainer.querySelector(`.interactive-text-item.${INTX_ACTIVE_CLASS}`);
                const activeButton = ItTab.querySelector(`.intx-item-btn.${INTX_ACTIVE_CLASS}`);
                activeItem?.classList.remove(INTX_ACTIVE_CLASS);
                activeButton?.classList.remove(INTX_ACTIVE_CLASS);
            };

            const items = interactiveTextContainer.querySelectorAll('.interactive-text-item');
            items.forEach(item => {
                const interactiveButton = item.querySelector('.intx-item-btn');
                if (interactiveButton) {
                    buttonContainer.appendChild(interactiveButton);
                    // item.removeChild(interactiveButton);

                    interactiveButton.addEventListener('click', () => {
                        if (!interactiveButton.classList.contains(INTX_ACTIVE_CLASS)) {
                            removeItemsActiveClass();
                            interactiveButton.classList.add(INTX_ACTIVE_CLASS);
                            item.classList.add(INTX_ACTIVE_CLASS);
                        }
                    });
                }
            });

            ItTab.prepend(buttonContainer);
        });
    });
};

document.addEventListener('DOMContentLoaded', PrepareInteractiveText);
